import React from 'react';
import moment from 'moment';
import { ShiftDetails, ShiftDetailsMobile } from '../../ShiftDetails';
import classNames from 'classnames';
import { Collapse } from 'reactstrap';

const TournamentListItem = (props) => {
  const [open, setOpen] = React.useState(true);
  const { shifts, idx, date, history } = props;

  return (
    <div className='tournament-list-item'>
      <div className='location-day-date' onClick={() => setOpen(!open)} >
        <i
          className={classNames('fas arrow', {
            'fa-chevron-down': open,
            'fa-chevron-right': !open,
          })}
        ></i>
        Day {idx + 1}: &nbsp;&nbsp;
        {moment(date).format('MM/DD/YY')}
      </div>
      <Collapse isOpen={open}>
        {
          shifts.map((shift, mapIdx) => {
            return (
              <React.Fragment key={`card-body-${mapIdx}`}>
                <ShiftDetails
                  shifts={shifts}
                  shift={shift}
                  idx={mapIdx}
                  onDeleteShift={props.onDeleteShift}
                  canDeleteShift={props.canDeleteShift}
                  isTournament={props.isTournament}
                  editMode={props.editMode}
                  history={history}
                />
                <ShiftDetailsMobile
                  shifts={shifts}
                  shift={shift}
                  idx={shift.idx}
                  onDeleteShift={props.onDeleteShift}
                  canDeleteShift={props.canDeleteShift}
                  isTournament={props.isTournament}
                  editMode={props.editMode}
                  history={history}
                />
              </React.Fragment>
            );
          })
        }
      </Collapse>
    </div>
  )
}

export default TournamentListItem;
